import { render, staticRenderFns } from "./productAnalysisType.vue?vue&type=template&id=44519464&scoped=true&"
import script from "./productAnalysisType.vue?vue&type=script&lang=js&"
export * from "./productAnalysisType.vue?vue&type=script&lang=js&"
import style0 from "./productAnalysisType.vue?vue&type=style&index=0&id=44519464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44519464",
  null
  
)

export default component.exports